import { create } from 'zustand';
import { ApiUtils, PrintUtils } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface UsePrintStatementsStore {
  loading: boolean;
  data: boolean | null;
  error: string | null;
  printStatements: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const usePrintStatementsStore = create<UsePrintStatementsStore>((set) => ({
  data: null,
  loading: false,
  error: null,

  printStatements: async (cardId, signal) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await CardsApi.printStatements(cardId, signal);
      PrintUtils.printPDF(result.data);
      set({ loading: false, data: true });
    } catch (error) {
      set({ loading: false, data: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
